import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers} from '@angular/http';
import { ChangeAssignedBrokerService } from '../../app/services/change-assigned-brokerService';

@Component({
  selector: 'page-change-assigned-broker',
  templateUrl: 'change-assigned-broker.html',
})
export class ChangeAssignedBrokerPage {
    changeAssignedBrokerForm: FormGroup;
    public form_name: any;
    public getRole: any;
    public header_title: any;
    public allBrokers: any;
    public userRole: any;
    public contactDetails: any;
    public contact_uid: any;
    public secondary_contact: any;
    public SDF_form_document_id: any;

    public validation_messages = {
      'broker': [
          { type: 'required', message: 'Broker is required.' }
      ]
    }
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    public db: AngularFirestore,
    public ChangeAssignedBrokerService: ChangeAssignedBrokerService
  ) {    
    this.form_name = "eLINK Finance";
    this.header_title = "Change Assigned Broker";
    //let uid = window.localStorage.getItem("uid");
    this.changeAssignedBrokerForm = formBuilder.group({
      reference_broker: ['', Validators.compose([Validators.required])]
    });
    this.contact_uid = this.navParams.get("contact_uid");
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    this.getAllBrokers().subscribe((data)=>{
      this.allBrokers = data;
    });
    this.getContactDetails().subscribe((data)=>{
      if(data.length > 0){
        this.contactDetails = data[0].firstname+' '+data[0].lastname;
        this.secondary_contact = data[0].secondary_contact_uid;
        this.changeAssignedBrokerForm.controls.reference_broker.setValue(data[0].reference_broker);
      }
    });    
    this.userRole = window.localStorage.getItem("userRole");     
  }

  getAllBrokers (){
    return this.db.collection<any>( "users" , ref => ref.where('roles.broker','==',true )).valueChanges ();
  }

  getContactDetails (){
    return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',this.contact_uid )).valueChanges ();
  }

  isFieldValid(field: string) {
    return !this.changeAssignedBrokerForm.get(field).valid && this.changeAssignedBrokerForm.get(field).touched;
  }
  
  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  public closeModal(){
    this.navCtrl.pop();
  }

  change_assigned_broker(){
    let thiss = this;
    if(!this.changeAssignedBrokerForm.valid){
      this.changeAssignedBrokerForm.get('reference_broker').markAsDirty();
      this.changeAssignedBrokerForm.get('reference_broker').markAsTouched();
    }else{
      //this.loadingProvider.startLoading();
      let uid = window.localStorage.getItem("uid");
      if(uid != null){
        let reference_broker = this.changeAssignedBrokerForm.value.reference_broker;

        // var headers = new Headers();
        // headers.append("Accept", 'application/json');
        // headers.append('Content-Type', 'application/json' );
        // const requestOptions = new RequestOptions({ headers: headers });

        // if(this.secondary_contact == "" || this.secondary_contact == null || this.secondary_contact == undefined){
        //   this.secondary_contact = '';
        // }

        let postData = {
          "reference_broker": reference_broker,
          "contact_uid": this.contact_uid,
          "SDF_form_document_id": this.SDF_form_document_id
        }
        console.log('postData', postData);
        if(postData.SDF_form_document_id == "" || postData.SDF_form_document_id == null || postData.SDF_form_document_id == undefined){}else{
            this.getAllContactBySDFID(postData.SDF_form_document_id).subscribe((contacts)=>{
                console.log(contacts);
                if(contacts.length > 0){
                    Object.keys(contacts).forEach(function(key) {
                      thiss.changeAssignedBroker(contacts[key], postData.reference_broker);
                    });
                }
                thiss.presentToast('updated successfully'); 
            });
        }
        
        // this.http.post("https://us-central1-loan-management-sandbox.cloudfunctions.net/changeAssignedBroker", postData, requestOptions)
        // .subscribe(data => {
        //   if(data['_body'] == 'success'){
        //     this.loadingProvider.stopLoading();  
        //     this.presentToast('updated successfully'); 
        //     this.navCtrl.pop();         
        //   }else{
        //     this.loadingProvider.stopLoading();
        //     this.presentToast('Something went wrong please try again later.');
        //   }
        // }, error => {
        //   this.loadingProvider.stopLoading();
        //   this.presentToast(error.message);
        // });
      }
    }
  }

  changeAssignedBroker(contacts, reference_broker){
    console.log(contacts);
    const usersData = this.db.collection('/users_data');
    usersData.doc(contacts.document_id).update({
      reference_broker: reference_broker
    });
  }

  getAllContactBySDFID(SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',SDF_form_document_id ).where('deleted','==',0 )).valueChanges ();
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ionViewDidLoad() {
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-assigned-broker/change-assigned-broker.ts